<template>
  <div class="mention-textarea">
    <textarea
      ref="input"
      :value="modelValue"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="inputClass"
      :style="inputStyle"
      @input="onInput"
      @keydown="onKeydown"
      @keyup="syncMention"
      @click="syncMention"
      @blur="closeSoon"
    ></textarea>
    <MentionSuggest
      :open="open"
      :items="filtered"
      :active-index="activeIndex"
      :anchor="anchor"
      @pick="insertUser"
      @hover="activeIndex = $event"
    />
  </div>
</template>

<script>
import MentionSuggest from "@/components/MentionSuggest.vue";
import {
  filterMentionUsers,
  getMentionQuery,
  insertMention,
  loadMentionUsers,
} from "@/utils/mentionUsers";

export default {
  name: "MentionTextarea",
  components: { MentionSuggest },
  props: {
    modelValue: { type: String, default: "" },
    rows: { type: [Number, String], default: 3 },
    placeholder: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    inputClass: { type: [String, Object, Array], default: "form-control form-control-sm" },
    inputStyle: { type: [String, Object], default: "" },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      users: [],
      open: false,
      query: null,
      activeIndex: 0,
      anchor: null,
    };
  },
  computed: {
    filtered() {
      return filterMentionUsers(this.users, this.query?.query);
    },
  },
  watch: {
    filtered() {
      this.activeIndex = 0;
    },
  },
  mounted() {
    loadMentionUsers().then((rows) => {
      this.users = rows;
    });
  },
  methods: {
    onInput(e) {
      this.$emit("update:modelValue", e.target.value);
      this.$nextTick(this.syncMention);
    },
    onKeydown(e) {
      if (!this.open || !this.filtered.length) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        this.activeIndex = (this.activeIndex + 1) % this.filtered.length;
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        this.activeIndex = (this.activeIndex - 1 + this.filtered.length) % this.filtered.length;
      } else if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault();
        this.insertUser(this.filtered[this.activeIndex]);
      } else if (e.key === "Escape") {
        e.preventDefault();
        this.open = false;
      }
    },
    syncMention() {
      const el = this.$refs.input;
      if (!el) return;
      const found = getMentionQuery(el.value, el.selectionStart);
      this.query = found;
      this.open = !!found;
      if (found) {
        const rect = el.getBoundingClientRect();
        this.anchor = {
          top: rect.bottom + 4,
          left: rect.left,
          width: Math.max(220, Math.min(rect.width, 320)),
        };
      }
    },
    insertUser(user) {
      const el = this.$refs.input;
      if (!el || !user || !this.query) return;
      const next = insertMention(el.value, el.selectionStart, this.query.start, user);
      this.$emit("update:modelValue", next.value);
      this.open = false;
      this.query = null;
      this.$nextTick(() => {
        el.focus();
        el.setSelectionRange(next.cursor, next.cursor);
      });
    },
    closeSoon() {
      window.setTimeout(() => {
        this.open = false;
      }, 120);
    },
  },
};
</script>

<style scoped>
.mention-textarea {
  position: relative;
  width: 100%;
}

.mention-textarea textarea {
  width: 100%;
}
</style>
